import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const TradingWidget = () => {
  const [selectedExchange, setSelectedExchange] = useState('binance');
  const [selectedPair, setSelectedPair] = useState('BTC/USDT');

  const exchanges = [
    { value: 'binance', label: 'Binance', volume: '$24.2B', pairs: 1500 },
    { value: 'coinbase', label: 'Coinbase Pro', volume: '$8.7B', pairs: 280 },
    { value: 'kraken', label: 'Kraken', volume: '$2.1B', pairs: 190 },
    { value: 'huobi', label: 'Huobi Global', volume: '$5.4B', pairs: 650 }
  ];

  const tradingPairs = [
    { value: 'BTC/USDT', label: 'BTC/USDT', price: 43250.50, change: 2.34 },
    { value: 'ETH/USDT', label: 'ETH/USDT', price: 2456.78, change: -1.23 },
    { value: 'AOGX/USDT', label: 'AOGX/USDT', price: 0.9234, change: 5.67 },
    { value: 'ADA/USDT', label: 'ADA/USDT', price: 0.4521, change: 3.45 },
    { value: 'SOL/USDT', label: 'SOL/USDT', price: 98.34, change: -2.11 }
  ];

  const exchangeOptions = exchanges?.map(exchange => ({
    value: exchange?.value,
    label: exchange?.label
  }));

  const pairOptions = tradingPairs?.map(pair => ({
    value: pair?.value,
    label: pair?.label
  }));

  const currentExchange = exchanges?.find(ex => ex?.value === selectedExchange);
  const currentPair = tradingPairs?.find(pair => pair?.value === selectedPair);

  return (
    <div className="bg-card border border-border rounded-brand p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground">Trading Integration</h3>
          <p className="text-sm text-muted-foreground">Connect with major cryptocurrency exchanges</p>
        </div>
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
          <span className="text-sm text-success font-medium">Live Data</span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <Select
          label="Exchange"
          options={exchangeOptions}
          value={selectedExchange}
          onChange={setSelectedExchange}
        />
        
        <Select
          label="Trading Pair"
          options={pairOptions}
          value={selectedPair}
          onChange={setSelectedPair}
        />
      </div>
      {currentExchange && (
        <div className="bg-muted/50 rounded-brand-sm p-4 mb-6">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-primary rounded-brand-sm flex items-center justify-center">
                <span className="text-white font-bold text-sm">
                  {currentExchange?.label?.charAt(0)}
                </span>
              </div>
              <div>
                <h4 className="font-semibold text-foreground">{currentExchange?.label}</h4>
                <p className="text-sm text-muted-foreground">24h Volume: {currentExchange?.volume}</p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-sm text-muted-foreground">Trading Pairs</p>
              <p className="font-semibold text-foreground">{currentExchange?.pairs?.toLocaleString()}</p>
            </div>
          </div>

          {currentPair && (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="bg-background rounded-brand-xs p-3">
                <p className="text-xs text-muted-foreground">Current Price</p>
                <p className="font-bold text-foreground">
                  ${currentPair?.price?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 6 })}
                </p>
              </div>
              <div className="bg-background rounded-brand-xs p-3">
                <p className="text-xs text-muted-foreground">24h Change</p>
                <p className={`font-bold ${currentPair?.change >= 0 ? 'text-success' : 'text-destructive'}`}>
                  {currentPair?.change >= 0 ? '+' : ''}{currentPair?.change?.toFixed(2)}%
                </p>
              </div>
              <div className="bg-background rounded-brand-xs p-3">
                <p className="text-xs text-muted-foreground">Spread</p>
                <p className="font-bold text-foreground">0.02%</p>
              </div>
              <div className="bg-background rounded-brand-xs p-3">
                <p className="text-xs text-muted-foreground">Liquidity</p>
                <p className="font-bold text-success">High</p>
              </div>
            </div>
          )}
        </div>
      )}
      <div className="space-y-4">
        <h4 className="font-medium text-foreground">Quick Actions</h4>
        
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <Button
            variant="outline"
            className="justify-start h-auto p-4"
            iconName="ExternalLink"
            iconPosition="right"
          >
            <div className="text-left">
              <p className="font-medium">Trade on {currentExchange?.label}</p>
              <p className="text-xs text-muted-foreground">Open exchange platform</p>
            </div>
          </Button>
          
          <Button
            variant="outline"
            className="justify-start h-auto p-4"
            iconName="BarChart3"
            iconPosition="right"
          >
            <div className="text-left">
              <p className="font-medium">Advanced Charts</p>
              <p className="text-xs text-muted-foreground">TradingView integration</p>
            </div>
          </Button>
          
          <Button
            variant="outline"
            className="justify-start h-auto p-4"
            iconName="Wallet"
            iconPosition="right"
          >
            <div className="text-left">
              <p className="font-medium">Portfolio Sync</p>
              <p className="text-xs text-muted-foreground">Connect your wallet</p>
            </div>
          </Button>
        </div>
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2 text-muted-foreground">
              <Icon name="Shield" size={16} />
              <span>Secure API connections</span>
            </div>
            <div className="flex items-center space-x-2 text-muted-foreground">
              <Icon name="Zap" size={16} />
              <span>Real-time data feeds</span>
            </div>
          </div>
          <Button variant="ghost" size="sm" iconName="Settings" iconPosition="left">
            Configure
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TradingWidget;